module.exports = __webpack_public_path__ + "img/product8.3f39bdf8.jpg";